var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60746 10.2561C4.11901 8.39561 2.34564 6.34915 1.37734 5.19867C1.0776 4.84253 0.979381 4.5819 0.920326 4.1228C0.718115 2.5508 0.617009 1.7648 1.07795 1.2574C1.5389 0.75 2.35404 0.75 3.98433 0.75H15.5157C17.146 0.75 17.9611 0.75 18.422 1.2574C18.883 1.7648 18.7819 2.5508 18.5797 4.12281C18.5206 4.58191 18.4224 4.84254 18.1226 5.19867C17.153 6.35062 15.3761 8.40071 12.8826 10.2635C12.657 10.4321 12.5083 10.7067 12.4807 11.0114C12.2337 13.742 12.0059 15.2376 11.8641 15.9942C11.6353 17.2157 9.90316 17.9506 8.97601 18.6063C8.42406 18.9966 7.7543 18.532 7.68278 17.9278C7.54643 16.7761 7.28961 14.4364 7.00927 11.0114C6.98409 10.7039 6.83486 10.4261 6.60746 10.2561Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.309c7bfc5a38ec20dfc76f2f6bdddf1b.svg";
export { ForwardRef as ReactComponent };